import { put, select, call, take } from 'redux-saga/effects'
import moment from "moment";
import queryString from "query-string";
import logger from "lib/log";
import * as appActions from "state/app/actions";
import {getClientInitDate, getUserIdentity} from "state/app/selectors";
import {isCheckoutWindowOpen} from "state/school_money/selectors";
import { processSecureTradingPaymentResponse } from "state/school_money/actions";

/**
*   const urlUserIdentity = {
    mobileNumber: urlArgs.mobile_number,
    deviceToken:  urlArgs.device_token,

    appReferrer:  urlArgs.app_referrer,
    metadata:     urlArgs.metadata,
    platform:     urlArgs.platform,
    appVersion:   urlArgs.app_version,
    os:           urlArgs.os,
    osVersion:    urlArgs.os_version,
    device:       urlArgs.device
  }
*/
function buildTargetURLfromUserIdentity(stateUserIdentity) {
  const queryArgs = {};
  const userIdentity = stateUserIdentity.toJS();
  // Blank the metadata, as that only applies to the first load
  // Delete status as that's an internal property
  delete userIdentity.metadata;
  delete userIdentity.status;

  // Translate the arguments back to url args
  // map only the camelcased versions that need translating
  for( const keyName in userIdentity) {
    if (userIdentity.hasOwnProperty(keyName)) {
      switch(keyName) {
        case "mobileNumber":
            queryArgs.mobile_number = userIdentity[keyName];
          break;
        case "deviceToken":
            queryArgs.device_token = userIdentity[keyName];
          break;
        case "appReferrer":
            queryArgs.app_referrer = userIdentity[keyName];
          break;
        case "appVersion":
            queryArgs.app_version = userIdentity[keyName];
          break;
        case "osVersion":
            queryArgs.os_version = userIdentity[keyName];
          break;
        default:
          break;
      }
    }
  }
  // build the query string from the translated args
  const targetQueryString = queryString.stringify(queryArgs);

  return `${process.env.PUBLIC_URL}/?${targetQueryString}${window.location.hash}`;
}

// Prevents app refresh if CheckoutWindow is open
function* waitForCheckoutWindowToClose(){
  while ((yield select(isCheckoutWindowOpen))) {
    yield take();
  }
}

// Pushes user to specific parts of app depending on notification payload
export default function* processMetadataSaga(action) {

  logger.debug(`Process Metadata: got metadata: ${action.payload.metadata}`);

  // Check for empty metadata passed from native
  if (action.payload.metadata === "") {
    return;
  }
  
  // Check for clientInitDate older than a day
  const clientInitDateString = yield select(getClientInitDate);
  const clientInitDate = moment.unix(clientInitDateString);

  yield call(waitForCheckoutWindowToClose);

  // If web client is out of date, reload the web client ( more than 1 DAY old)
  if( moment().diff(clientInitDate, "days") > 0 ) {
    logger.debug("Process Metadata: client is stale, refreshing...");
    yield put( appActions.clearClientInitDate() );
    const userIdentity =  (yield select(getUserIdentity) );
    const targetURLHref = buildTargetURLfromUserIdentity(userIdentity);

    window.location.href = targetURLHref;
  }

  if (action.payload.metadata === "refresh" || action.payload.metadata === undefined) {
    yield put(appActions.fetchAvailableProducts());
  }
  yield put(appActions.openLoadingFrame());
}

export function* processGooglePayResponseSaga(paymentResponse) {
  paymentResponse = JSON.parse(paymentResponse.payload.response);
  yield put(
    processSecureTradingPaymentResponse(
      {
        errorcode: paymentResponse.paymentResponse === "success" ? "0" : paymentResponse.errorDescription,
        errormessage: "",
        jwt: paymentResponse.jwt
      }
    )
  );
}



// WEBPACK FOOTER //
// ./src/state/app/sagas/processMetadata.js